export default `
  query {
    photoproductEvidences {
      evidences {
        evidence_id
        type
        label
        link
      }
    }
  }
`;
